import * as types from "../actionTypes";

export const setAdvertisementExpenseByYear = (key, yearKey, amount) => {
  return (dispatch) => {
    return dispatch({
      type: types.SET_ADVERTISEMENT_EXPENSE_BY_YEAR,
      key,
      yearKey,
      amount,
    });
  };
};

export const setAdvertisementExpenseByMonths = (key, yearKey, amount) => {
  return (dispatch) => {
    return dispatch({
      type: types.SET_ADVERTISEMENT_EXPENSE_BY_MONTHS,
      key,
      yearKey,
      amount,
    });
  };
};

export const replaceAdvertisementExpenseYears = (key, payload) => {
  return (dispatch) => {
    return dispatch({
      type: types.REPLACE_ADVERTISEMENT_EXPENSE_YEARS,
      key,
      payload,
    });
  };
};

export const resetAdvertisementExpenseReducer = () => {
  return (dispatch) => {
    return dispatch({
      type: types.RESET_ADVERTISEMENT_EXPENSE_REDUCER,
    });
  };
};
